import styled from '@emotion/styled';
import KizenTypography from 'app/kizentypo';
import { gutters } from 'app/spacing';

const Wrapper = styled.div`
  padding: ${gutters.spacing(1)}px;
`;

export default function Section({ title = '', children, ...others }) {
  return (
    <Wrapper {...others}>
      {title && (
        <KizenTypography type="header" margin="lg">
          {title}
        </KizenTypography>
      )}
      {children}
    </Wrapper>
  );
}
